/* eslint-disable @typescript-eslint/indent */
/* eslint-disable semi */
import { MoreInfoType, RetirementResultType } from "../../result/helpers/types";
import {
  getMinContributionTime,
  getPercentualContribution,
  periodToDays,
  dateDiff,
  getPointsPublic,
  getMinAgeTimePublic,
  getMinAgeTimeTool,
} from "./functions";
import { Days, GenderType } from "./types";
import dayjs from "dayjs";

export const newRuleRetirement = (
  gender: GenderType,
  ageTime: Days,
  publicTime: Days,
  jobTime: Days,
  contributionTime: Days
): RetirementResultType => {
  const data: MoreInfoType[] = [];
  const title = "Voluntária Geral (Regra Geral)";
  const begin = dayjs(new Date());
  let today = dayjs(new Date());
  let minAgeTime =
    gender === "male" ? periodToDays(65, 0) : periodToDays(62, 0);
  let minContributionTime = periodToDays(25, 0);
  data.push({
    state: minContributionTime <= contributionTime,
    text: `Mínimo ${(minContributionTime / 365).toFixed(
      2
    )} anos de contribuição (Contribuição:  ${(contributionTime / 365).toFixed(
      2
    )} anos)`,
  });

  data.push({
    state: minAgeTime < ageTime,
    text: `Mínimo ${minAgeTime / 365} anos de idade (Atual: ${(
      ageTime / 365
    ).toFixed(2)} anos)`,
  });

  data.push({
    state: publicTime >= periodToDays(10, 0),
    text: `Mínimo 10 anos de serviço público (Serviço Publico: ${(
      publicTime / 365
    ).toFixed(2)} anos)`,
  });

  data.push({
    state: jobTime >= periodToDays(5, 0),
    text: `Mínimo 5 anos no cargo efetivo em que for concedida a aposentadoria (Último cargo: ${(
      jobTime / 365
    ).toFixed(2)} anos)`,
  });

  while (
    minAgeTime > ageTime ||
    minContributionTime > contributionTime ||
    publicTime < periodToDays(10, 0) ||
    jobTime < periodToDays(5, 0)
  ) {
    contributionTime += 365;
    ageTime += 365;
    today = today.add(365, "d");
    publicTime += 365;
    jobTime += 365;
  }

  const minDiffDays = Math.min(
    ageTime - minAgeTime,
    contributionTime - minContributionTime,
    publicTime - periodToDays(10, 0),
    jobTime - periodToDays(5, 0)
  );

  today = today.subtract(minDiffDays, "d");

  const minPercentual = getPercentualContribution(
    gender,
    { male: 20, female: 20 },
    2,
    60,
    contributionTime
  );

  const leftTimeRest =
    today.year() - begin.year() < 0 ? 0 : today.year() - begin.year();

  const percentual =
    String(minPercentual.toFixed(2)) + "% da Média Contributiva";

  return {
    title: title,
    type: "time",
    data: data,
    restDate: `${today.format("MM/YYYY")}`,
    leftTimeFull: false,
    leftTimeRest: leftTimeRest,
    percentual: percentual,
  };
};

export const pointsRetirement = (
  gender: GenderType,
  ageTime: Days,
  publicTime: Days,
  jobTime: Days,
  contributionTime: Days,
  before1998: boolean,
  before2003: boolean,
  before2020: boolean
): RetirementResultType => {
  const minContributionTime = getMinContributionTime(gender); // Valor fixo contribuição minima
  const minAgeIntegral =
    gender === "male" ? periodToDays(65, 0) : periodToDays(60, 0); // Valor fixo idade minima
  const data: MoreInfoType[] = [];
  const begin = dayjs(new Date());
  let today = dayjs(new Date());
  const title = "Regra dos Pontos";
  let minAgeTime = getMinAgeTimePublic(gender, today.year());
  let acumulatedDaysPoints = contributionTime + ageTime;
  let dayPoints = getPointsPublic(gender, today);
  let messagePercentual = "";
  let messageFull: string | boolean = "";
  let minAgePublic = getMinAgeTimePublic(gender, today.year());
  let diffContributionMin = contributionTime - minContributionTime;
  if (before1998 && contributionTime > minContributionTime)
    minAgeTime = minAgePublic - diffContributionMin;

  data.push({
    state: ageTime >= minAgeTime,
    text: `Mínimo ${(minAgeTime / 365).toFixed(2)} anos de idade (Idade:  ${(
      ageTime / 365
    ).toFixed(2)} anos)`,
  });

  data.push({
    state: contributionTime >= minContributionTime,
    text: `Mínimo ${(minContributionTime / 365).toFixed(
      2
    )} anos de contribuição (Contribuição:  ${(contributionTime / 365).toFixed(
      2
    )} anos)`,
  });

  data.push({
    state: contributionTime + ageTime >= dayPoints,
    text: `Mínimo ${Math.floor(dayPoints / 365)} pontos (Contribuição: ${(
      contributionTime / 365
    ).toFixed(2)} anos + Idade: ${(ageTime / 365).toFixed(2)} anos)`,
  });

  data.push({
    state: publicTime >= periodToDays(10, 0),
    text: `Mínimo 10 anos de serviço público (Serviço Publico: ${(
      publicTime / 365
    ).toFixed(2)} anos)`,
  });

  data.push({
    state: jobTime >= periodToDays(5, 0),
    text: `Mínimo 5 anos no cargo efetivo em que for concedida a aposentadoria (Último cargo: ${(
      jobTime / 365
    ).toFixed(2)} anos)`,
  });

  while (
    acumulatedDaysPoints < dayPoints ||
    contributionTime < minContributionTime ||
    publicTime < periodToDays(10, 0) ||
    jobTime < periodToDays(5, 0) ||
    ageTime < minAgeTime
  ) {
    contributionTime += 1;
    ageTime += 1;
    today = today.add(1, "day");

    dayPoints = getPointsPublic(gender, today);
    publicTime += 1;
    jobTime += 1;

    minAgePublic = getMinAgeTimePublic(gender, today.year());
    diffContributionMin = contributionTime - minContributionTime;

    if (before1998 && contributionTime > minContributionTime)
      minAgeTime = minAgePublic - diffContributionMin;
    else minAgeTime = getMinAgeTimePublic(gender, today.year());

    acumulatedDaysPoints = contributionTime + ageTime;
  }

  const minDiffDays = Math.min(
    ageTime - minAgeTime,
    acumulatedDaysPoints - dayPoints,
    contributionTime - minContributionTime,
    publicTime - periodToDays(10, 0),
    jobTime - periodToDays(5, 0)
  );

  today = today.subtract(minDiffDays, "d");

  const leftTimeRest =
    today.year() - begin.year() < 0 ? 0 : today.year() - begin.year();
  let integralTime = Number(((minAgeIntegral - ageTime) / 365).toFixed(2));
  const leftTimeFull = before2003 && integralTime > 0 ? integralTime : 0;

  if (before2003) {
    messagePercentual =
      ageTime > minAgeIntegral
        ? "Paridade e Integralidade"
        : "100%  Média Contributiva";
    messageFull =
      "Mais " + leftTimeFull + " ano(s) para a integralidade e paridade";
  } else if (before2020) {
    messagePercentual = "100%  Média Contributiva (Descarte piores 20%)";
    messageFull = false;
  } else {
    messagePercentual = "100%  Média Contributiva";
    messageFull = false;
  }

  return {
    title: title,
    type: "points",
    data: data,
    restDate: `${today.format("MM/YYYY")}`,
    leftTimeFull: messageFull,
    leftTimeRest: leftTimeRest,
    percentual: messagePercentual,
  };
};

export const toll50Retirement = (
  gender: GenderType,
  contributionTime: Days,
  publicTime: Days,
  jobTime: Days,
  ageTime: Days,
  before1998: boolean,
  before2003: boolean,
  before2020: boolean
): RetirementResultType => {
  let messagePercentual = "";
  let messageFull: string | boolean = "";

  const minContributionTimeaFixed = getMinContributionTime(gender); // Valor fixo contribuição minima
  const data: MoreInfoType[] = [];
  const title = "Pedágio de 50%";
  const begin = dayjs(new Date());
  let today = dayjs(new Date());

  const reformTime = dateDiff(new Date(), new Date(2020, 8, 14));
  const maleDifference = periodToDays(35, 0) - (contributionTime - reformTime);
  const femaleDifference =
    periodToDays(30, 0) - (contributionTime - reformTime);
  const minContributionTime =
    gender === "male"
      ? maleDifference > 0
        ? periodToDays(35, 0) + maleDifference / 2
        : periodToDays(35, 0)
      : femaleDifference > 0
      ? periodToDays(30, 0) + femaleDifference / 2
      : periodToDays(30, 0);

  let minAgeTime = getMinAgeTimeTool(gender);
  let diffContributionMin = contributionTime - minContributionTimeaFixed;
  if (before1998 && contributionTime > minContributionTimeaFixed)
    minAgeTime = getMinAgeTimeTool(gender) - diffContributionMin;

  data.push({
    state: ageTime >= minAgeTime,
    text: `Mínimo ${(minAgeTime / 365).toFixed(2)} anos de idade (Idade:  ${(
      ageTime / 365
    ).toFixed(2)} anos)`,
  });

  data.push({
    state: contributionTime >= minContributionTime,
    text: `Mínimo ${(minContributionTime / 365).toFixed(
      2
    )} anos de contribuição até a vigência da reforma  (Contribuição Atual:  ${(
      contributionTime / 365
    ).toFixed(2)} anos)`,
  });

  data.push({
    state: publicTime >= periodToDays(10, 0),
    text: `Mínimo 10 anos de serviço público (Serviço Publico: ${(
      publicTime / 365
    ).toFixed(2)} anos)`,
  });

  data.push({
    state: jobTime >= periodToDays(5, 0),
    text: `Mínimo 5 anos no cargo efetivo em que for concedida a aposentadoria (Último cargo: ${(
      jobTime / 365
    ).toFixed(2)} anos)`,
  });

  while (
    contributionTime < minContributionTime ||
    publicTime < periodToDays(10, 0) ||
    jobTime < periodToDays(5, 0) ||
    ageTime < minAgeTime
  ) {
    contributionTime += 1;
    ageTime += 1;
    today = today.add(1, "day");

    publicTime += 1;
    jobTime += 1;

    diffContributionMin = contributionTime - minContributionTimeaFixed;
    if (before1998 && contributionTime > minContributionTimeaFixed)
      minAgeTime = getMinAgeTimeTool(gender) - diffContributionMin;
    else minAgeTime = getMinAgeTimeTool(gender);
  }

  const minDiffDays = Math.min(
    ageTime - minAgeTime,
    contributionTime - minContributionTime,
    publicTime - periodToDays(10, 0),
    jobTime - periodToDays(5, 0)
  );

  today = today.subtract(minDiffDays, "d");
  const leftTimeRest =
    today.year() - begin.year() < 0 ? 0 : today.year() - begin.year();
  let integralTime = Number(((minAgeTime - ageTime) / 365).toFixed(2));

  const leftTimeFull = before2003 && integralTime > 0 ? integralTime : 0;

  if (before2003) {
    messagePercentual =
      ageTime > minAgeTime
        ? "Paridade e Integralidade"
        : "100%  Média Contributiva";
    messageFull =
      "Mais " + leftTimeFull + " ano(s) para a integralidade e paridade";
  } else if (before2020) {
    messagePercentual = "100%  Média Contributiva (Descarte piores 20%)";
    messageFull = false;
  } else {
    messagePercentual = "100%  Média Contributiva";
    messageFull = false;
  }

  return {
    title: title,
    type: "minimal",
    data: data,
    restDate: `${today.format("MM/YYYY")}`,
    leftTimeFull: messageFull,
    leftTimeRest: leftTimeRest,
    percentual: messagePercentual,
  };
};
